export interface CapacityLabelInput {
  capacityLabel?: string | null;
  capacityTechnologyName?: string | null;
  capacityTypeName?: string | null;
  capacitySeniorityName?: string | null;
  resourceTypeName?: string | null;
  technologyName?: string | null;
  seniorityName?: string | null;
}

const normalize = (value?: string | null): string | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const trimmed = value.trim();
  return trimmed ? trimmed : null;
};

export const formatCapacityLabel = (
  input: CapacityLabelInput | null | undefined
): string | null => {
  if (!input) {
    return null;
  }

  const direct = normalize(input.capacityLabel);
  if (direct) {
    return direct;
  }

  const technology =
    normalize(input.capacityTechnologyName) ?? normalize(input.technologyName);
  const type =
    normalize(input.capacityTypeName) ?? normalize(input.resourceTypeName);
  const seniority =
    normalize(input.capacitySeniorityName) ?? normalize(input.seniorityName);

  const parts = [technology, type].filter(Boolean) as string[];
  const base = parts.join(' • ');

  if (!base && !seniority) {
    return null;
  }

  if (!base) {
    return seniority;
  }

  if (!seniority) {
    return base;
  }

  return `${base} (${seniority})`;
};

export default formatCapacityLabel;
